import type { DayActivityHistory } from '@openeducation/oe-rn-shared-types';
import { styled } from '@openeducation/oe-rn-themes';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { View } from 'react-native';

import { ActivityHistoryItem } from './activity-history-item';
import { OEText } from '../../atoms';
import { flex } from '../../style-utils';

export interface ActivityHistoryProps {
  data: DayActivityHistory[];
}
export const ActivityHistory = ({ data = [] }: ActivityHistoryProps) => {
  const { t } = useTranslation();
  return (
    <Container>
      {data.length === 0 ? (
        <View
          style={[
            flex('align-items-center', 'justify-content-center', 'flex-1'),
          ]}
        >
          <OEText>{t('hr2.common.chart.noData')}</OEText>
        </View>
      ) : (
        data.map((item) => (
          <ActivityHistoryItem
            key={`${item.courseType}-${
              item.courseTitle
            }-${item.dateStarted.toString()}-${item.dateCompleted.toString()}`}
            {...item}
          />
        ))
      )}
    </Container>
  );
};

const Container = styled.View`
  width: 100%;
  height: 100%;
  max-height: 390px;
  overflow: auto;
  margin-top: 12px;
`;
